import { CoreIcon } from '../core-icon';
import timeSVG from '../../assets/icons/time.svg';
import type { IconProps } from '../core-icon';

export const TimeIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={timeSVG} {...props} />;
};
